import React from 'react';
import './style.css'

const ContentHeading = ({ heading, action: action, pro=false}) => {
    return (
        <div className={`content-heading-step ${pro ? 'content-heading-pro' : ''}`}> 
            <div className={'content-heading'}>
                <span>{heading}</span>
            </div>
            <div className='content-heading-action'>
                {action}
            </div>
        </div>
    );
};

export default ContentHeading;
